<template>
  <div v-if="notes.length > 0">
    <a v-for="(note, index) in notes" :key="index" :href="note.links.url" class="block px-4 py-2 text-sm border-t hover:bg-default-200">
      <div class="flex justify-between font-semibold">
        <small>{{ note.publication.category.name }}</small>
        <small>{{ note.publication.publication_at }}</small>
      </div>
      <h6>{{ note.title }}</h6>
    </a>
  </div>
  <div v-else class="rounded-lg p-2 mx-4 mb-4 bg-yellow-100 text-yellow-900">
    Não existem notas cadastradas
  </div>
</template>

<script>
import Semed from "../api/Semed";

export default {
  name: "NoteComponent",
  data() {
    return {
      notes: {},
    };
  },
  created() {
    Semed.get("/institutional/notes/category/educacao").then((response) => {
      this.notes = response.data;
    });
  },
};
</script>

<style scoped>
.list-note h6 {
  font-size: 0.8rem;
  font-weight: bold;
  margin: 0;
}
.header-note small {
  font-size: 0.7rem;
  font-weight: bold;
}
.list-note .list-group-item {
  padding: 0.5rem;
}
</style>
